@if (tyre.width && tyre.height && tyre.diameter) {
  {{ tyre.width | number: '1.0' }}/{{ tyre.height | number: '1.0' }}R{{ tyre.diameter }}
} @else {
  -
}
